// src/pages/BrowsePage.js
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./BrowsePage.css";
import MapView from "../components/MapView";
import SpeechIcon from "../components/SpeechIcon";
import { useAuth } from "../auth/AuthProvider";
import GateIcon from "../components/GateIcon";
import OfflineBanner from "../components/OfflineBanner";
import { getOffers, subscribeToOffers } from "../services/offersDataService";
import { useBlockedUsers } from "../hooks/useBlockedUsers";

function BrowsePage() {
    const [showMap, setShowMap] = useState(false);
  const [mapLightboxOpen, setMapLightboxOpen] = useState(false);

  const [allOffers, setAllOffers] = useState([]);
  const [filteredOffers, setFilteredOffers] = useState([]);

  const [searchPlz, setSearchPlz] = useState("");
  const [searchRadius, setSearchRadius] = useState("10");

const searchPlzRef = useRef("");
const searchRadiusRef = useRef("10");
useEffect(() => {
  searchPlzRef.current = searchPlz;
  searchRadiusRef.current = searchRadius;
}, [searchPlz, searchRadius]);


  

  const [mapCenter, setMapCenter] = useState(null);
  const [mapZoom, setMapZoom] = useState(12);
  const [mapKey, setMapKey] = useState(0);

  const [isOffline, setIsOffline] = useState(false);
  const [retryAttempt, setRetryAttempt] = useState(0);

 const [showLoginModal, setShowLoginModal] = useState(false);

  const [offersLoading, setOffersLoading] = useState(true);
  const [offersError, setOffersError] = useState("");
  const [hasRestoredState, setHasRestoredState] = useState(false);

 const [searchToast, setSearchToast] = useState("");
const [previewOfferId, setPreviewOfferId] = useState(null);
const previewTimerRef = useRef(null);
const searchToastTimerRef = useRef(null);
const plzInputRef = useRef(null);
const [plzShieldActive, setPlzShieldActive] = useState(false);
const plzShieldTimerRef = useRef(null);

const activatePlzShield = () => {
  if (plzShieldTimerRef.current) clearTimeout(plzShieldTimerRef.current);

  setPlzShieldActive(true);

  plzShieldTimerRef.current = setTimeout(() => {
    setPlzShieldActive(false);
  }, 500);
};


const showSearchToast = (text) => {
  if (searchToastTimerRef.current) clearTimeout(searchToastTimerRef.current);

  setSearchToast(text);

  searchToastTimerRef.current = setTimeout(() => {
    setSearchToast("");
  }, 2200);
};

  const navigate = useNavigate();
  const { user } = useAuth();

const myUid = user?.uid || null;
const isVerified = user?.emailVerified === true;
const { filterBlocked } = useBlockedUsers(myUid, isVerified);

  const saveBrowseState = (state) => {
    try {
      sessionStorage.setItem("browseState", JSON.stringify(state));
    } catch (e) {
      console.warn("BrowseState speichern fehlgeschlagen:", e);
    }
  };

  const loadBrowseState = () => {
    try {
      const saved = sessionStorage.getItem("browseState");
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  };

  const getRandomSubset = (list, limit = 20) => {
  if (!Array.isArray(list)) return [];

  return [...list]
    .sort((a, b) => {
      const at =
        a?.createdAt?.seconds ||
        a?.updatedAt?.seconds ||
        Date.parse(a?.createdAtClient || "") ||
        0;

      const bt =
        b?.createdAt?.seconds ||
        b?.updatedAt?.seconds ||
        Date.parse(b?.createdAtClient || "") ||
        0;

      if (bt !== at) return bt - at;

      return String(a?.id || "").localeCompare(String(b?.id || ""));
    })
    .slice(0, limit);
};

const filterOffersByRegion = (offers, plz, radius) => {
  const cleanPlz = (plz || "").trim();

  if (!cleanPlz) return Array.isArray(offers) ? offers : [];

  return (Array.isArray(offers) ? offers : []).filter((offer) => {
    const offerPlz = (offer.plz || (offer.seller && offer.seller.plz) || "").toString();

    if (!offerPlz) return false;

    switch (radius) {
      case "5":
        return offerPlz === cleanPlz;
      case "10":
        return offerPlz.substring(0, 3) === cleanPlz.substring(0, 3);
      case "20":
        return offerPlz.substring(0, 2) === cleanPlz.substring(0, 2);
      case "50":
      default:
        return offerPlz.charAt(0) === cleanPlz.charAt(0);
    }
  });
};


  useEffect(() => {
    const checkConnection = async () => {
      try {
        await fetch("https://www.gstatic.com/firebasejs/9.6.1/firebase-app.js", {
          method: "HEAD",
          cache: "no-store",
        });
        setIsOffline(false);
      } catch (err) {
        console.warn("Keine Server-Verbindung möglich (BrowsePage):", err);
        setIsOffline(true);
      }
    };

    checkConnection();
  }, [retryAttempt]);

  const handleOfflineRetry = () => {
    setIsOffline(false);
    setTimeout(() => setRetryAttempt((prev) => prev + 1), 600);
  };


    useEffect(() => {
    let mounted = true;
    let unsubscribe = null;

    const loadAndSubscribeOffers = async () => {
      setOffersLoading(true);
      setOffersError("");

      try {
        const offers = await getOffers();

        if (!mounted) return;

        setAllOffers(offers);

const visibleOffers = filterBlocked(offers);

const filtered = filterOffersByRegion(
  visibleOffers,
  searchPlzRef.current,
  searchRadiusRef.current
);

setFilteredOffers(
  !searchPlzRef.current ? getRandomSubset(visibleOffers, 20) : filtered
);

        if (offers.length === 0) {
          setOffersError("Noch keine Angebote vorhanden.");
        }

        const withCoords = offers.filter(
          (x) => Number.isFinite(Number(x.lat)) && Number.isFinite(Number(x.lng))
        );

        if (withCoords.length === 0 && offers.length > 0) {
          console.warn(
            "⚠️ Angebote geladen, aber KEINES hat lat/lng -> Karte kann keine Marker setzen. " +
              "Speichere Koordinaten beim Erstellen eines Angebots."
          );
        }

        unsubscribe = await subscribeToOffers(
          (liveOffers) => {
            if (!mounted) return;

          setAllOffers(liveOffers);

const visibleOffers = filterBlocked(liveOffers);

const currentPlz = searchPlzRef.current;
const currentRadius = searchRadiusRef.current;

const filtered = filterOffersByRegion(
  visibleOffers,
  currentPlz,
  currentRadius
);

setFilteredOffers(
  !currentPlz ? getRandomSubset(visibleOffers, 20) : filtered
);


            setOffersError(liveOffers.length === 0 ? "Noch keine Angebote vorhanden." : "");
            setOffersLoading(false);
          },
          (error) => {
            console.warn("Fehler im Angebote-Live-Listener:", error);

            if (mounted) {
              setOffersError("Angebote konnten nicht geladen werden (Firestore Fehler).");
              setOffersLoading(false);
            }
          }
        );
      } catch (err) {
        console.warn("Fehler beim Laden aus Firestore:", err);

        if (mounted) {
          setAllOffers([]);
          setFilteredOffers([]);
          setOffersError("Angebote konnten nicht geladen werden (Firestore Fehler).");
          setOffersLoading(false);
        }
      } finally {
        if (mounted) setOffersLoading(false);
      }
    };

        loadAndSubscribeOffers();

    return () => {
      mounted = false;

      if (typeof unsubscribe === "function") {
        unsubscribe();
      }
    };
  }, [filterBlocked]);

useEffect(() => {
  if (hasRestoredState) return;
  if (!allOffers.length) return;

  const saved = loadBrowseState();
  if (!saved) {
    setHasRestoredState(true);
    return;
  }

  const savedPlz = (saved.plz || "").trim();
  const savedRadius = saved.radius || "10";

  setSearchPlz(savedPlz);
  setSearchRadius(savedRadius);
  searchPlzRef.current = savedPlz;
searchRadiusRef.current = savedRadius;

  if (typeof saved.showMap === "boolean") {
    setShowMap(saved.showMap);
  }

  if (saved.center) setMapCenter(saved.center);
  if (saved.zoom) setMapZoom(saved.zoom);

 const visibleOffers = filterBlocked(allOffers);

if (!savedPlz) {
  setFilteredOffers(getRandomSubset(visibleOffers, 20));
  setHasRestoredState(true);
  return;
}


  const filtered = filterOffersByRegion(visibleOffers, savedPlz, savedRadius);

  setFilteredOffers(filtered);
  setSearchToast(
  filtered.length > 0
    ? `${filtered.length} Angebot${filtered.length === 1 ? "" : "e"} gefunden.`
    : "Keine Angebote in diesem Bereich gefunden."
);

setTimeout(() => {
  setSearchToast("");
}, 2500);
  setMapKey((prev) => prev + 1);

  setHasRestoredState(true);
}, [allOffers, hasRestoredState, filterBlocked]);

  
  const handleMapStateChange = ({ center, zoom }) => {
    setMapCenter(center);
    setMapZoom(zoom);

    saveBrowseState({
      plz: searchPlz,
      radius: searchRadius,
      showMap,
      center,
      zoom,
    });
  };

  const toggleView = () => {
    if (!myUid || !isVerified) {
  setShowLoginModal(true);
  return;
}

    const newValue = !showMap;
    setShowMap(newValue);

    saveBrowseState({
      plz: searchPlz,
      radius: searchRadius,
      showMap: newValue,
      center: mapCenter,
      zoom: mapZoom,
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") setMapLightboxOpen(false);
  };

  useEffect(() => {
    if (mapLightboxOpen) {
      document.addEventListener("keydown", handleKeyDown);
    } else {
      document.removeEventListener("keydown", handleKeyDown);
    }

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [mapLightboxOpen]);
useEffect(() => {
  return () => {
    if (previewTimerRef.current) clearTimeout(previewTimerRef.current);
    if (searchToastTimerRef.current) clearTimeout(searchToastTimerRef.current);
    if (plzShieldTimerRef.current) clearTimeout(plzShieldTimerRef.current);
  };
}, []);
  const geocodePlzToLatLng = async (plz) => {
    const clean = (plz || "").trim();
    if (!clean) return null;

    const url = `https://nominatim.openstreetmap.org/search?format=json&countrycodes=de&postalcode=${encodeURIComponent(
      clean
    )}&limit=1`;

    const res = await fetch(url, {
      headers: { Accept: "application/json", "Accept-Language": "de" },
    });

    if (!res.ok) throw new Error("nominatim-failed");

    const data = await res.json();
    if (!Array.isArray(data) || data.length === 0) return null;

    const lat = Number(data[0].lat);
    const lon = Number(data[0].lon);

    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
    return [lat, lon];
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();

    const plz = searchPlz.trim();
    const visibleOffers = filterBlocked(allOffers);

    if (!plz) {
  const randomOffers = getRandomSubset(visibleOffers, 20);

  setFilteredOffers(randomOffers);
  setMapCenter(null);
  setMapZoom(12);
  setMapKey((prev) => prev + 1);

  saveBrowseState({
    plz: "",
    radius: searchRadius,
    showMap,
    center: null,
    zoom: 12,
  });

  showSearchToast("Alle Regionen werden angezeigt.");

  return;
}

    const filtered = filterOffersByRegion(visibleOffers, plz, searchRadius);

setFilteredOffers(filtered);

showSearchToast(
  filtered.length > 0
    ? `${filtered.length} Angebot${filtered.length === 1 ? "" : "e"} gefunden.`
    : "Keine Angebote in dieser Region gefunden."
);

    try {
      const latlng = await geocodePlzToLatLng(plz);

      if (latlng) {
        setMapCenter(latlng);

        const z =
          searchRadius === "5"
            ? 13
            : searchRadius === "10"
            ? 12
            : searchRadius === "20"
            ? 11
            : 10;

        setMapZoom(z);
        setMapKey((prev) => prev + 1);

        saveBrowseState({
          plz,
          radius: searchRadius,
          showMap,
          center: latlng,
          zoom: z,
        });
      } else {
        setMapCenter(null);
        setMapZoom(12);
        setMapKey((prev) => prev + 1);

        saveBrowseState({
          plz,
          radius: searchRadius,
          showMap,
          center: null,
          zoom: 12,
        });
      }
    } catch (err) {
      console.warn("Geocoding fehlgeschlagen:", err);
      setMapCenter(null);
      setMapZoom(12);
      setMapKey((prev) => prev + 1);

      saveBrowseState({
        plz,
        radius: searchRadius,
        showMap,
        center: null,
        zoom: 12,
      });
    }
  };

  const hasOffers = filteredOffers.length > 0;

  return (
    <div className="BrowsePage">
      {isOffline && <OfflineBanner onRetry={handleOfflineRetry} />}

      <img
        src="/logo-edens-ernte-transparent.png"
        alt="Edens Ernte Logo"
        className="browse-logo"
        onClick={() => navigate("/")}
      />
      <GateIcon className="login-icon" />
      <SpeechIcon className="speech-icon no-tap-highlight" />
      <img
        src="/rezept-icon.png"
        alt="Rezepthelfer Icon"
        className="rezept-icon"
        onClick={() => navigate("/rezepte")}
      />
      <p className="top-claim">Nachhaltigkeit – ganz einfach!</p>

      <div className="browse-content">
        <h2>Finde Angebote aus deiner Region!</h2>
        <p>Gib deine Postleitzahl ein und entdecke lokale Tauschmöglichkeiten:</p>
{searchToast && (
  <div className="browse-inline-toast">
    {searchToast}
  </div>
)}
        <form
  className={`region-form ${plzShieldActive ? "plz-shield-active" : ""}`}
  onSubmit={(e) => {
    if (plzShieldActive) {
      e.preventDefault();
      return;
    }

    handleSearchSubmit(e);
  }}
>

          <div className="form-element">
          <input
  ref={plzInputRef}
  type="tel"
  inputMode="numeric"
  pattern="[0-9]*"
  placeholder="Postleitzahl"
  value={searchPlz}
  className="plz-input-ios-safe"
  autoComplete="postal-code"
  enterKeyHint="search"
  onPointerDown={() => activatePlzShield()}
  onTouchStart={() => activatePlzShield()}
  onFocus={() => {
  activatePlzShield();
}}
  onChange={(e) => setSearchPlz(e.target.value)}
/>
          </div>
          <div className="form-element">
          
 <select
  value={searchRadius}
  disabled={plzShieldActive}
  onChange={(e) => setSearchRadius(e.target.value)}
>

  <option value="5">Umkreis ~5 km</option>
  <option value="10">Umkreis ~10 km</option>
  <option value="20">Umkreis ~20 km</option>
  <option value="50">Umkreis ~50 km</option>
</select>
          </div>
          <div className="form-element">
            <button type="submit" disabled={plzShieldActive}>
  Suchen
</button>
          </div>
        </form>

        <div className="view-toggle">
          <button type="button" className="toggle-link" onClick={toggleView}>
            {showMap ? "Wechseln auf Listenansicht" : "Wechseln auf Kartenansicht"}
          </button>
        </div>

        {offersLoading && (
          <div className="admin-empty">
            <p>Angebote werden geladen…</p>
          </div>
        )}

        {!offersLoading && offersError && (
          <div className="admin-empty">
            <p>{offersError}</p>
          </div>
        )}

        <div className="fade-in">
          {showMap ? (
            <>
              <div className="embedded-map-wrapper">
                <MapView
                  key={mapKey}
                  offers={filteredOffers}
                  centerOverride={mapCenter}
                  zoomOverride={mapZoom}
                  onMapStateChange={handleMapStateChange}
                />
                <button className="fullscreen-map-btn" onClick={() => setMapLightboxOpen(true)}>
                  Karte vergrößern
                </button>
              </div>

              {!offersLoading && hasOffers && (
                <div className="admin-empty" style={{ marginTop: 10 }}>
                  <p>
                    Hinweis: Wenn der Ersteller in seinem Angebot seine Hausnummer nicht angegeben hat, wird der Blattmarker nur in der Nähe der genauen Adresse angezeigt.
                  </p>
                </div>
              )}
            </>
          ) : (
            <div className="suggestions">
              <h3>Vielleicht interessiert dich:</h3>

              {!offersLoading && !hasOffers && (
                <div className="admin-empty">
                  <p>Keine Angebote gefunden.</p>
                </div>
              )}

              {hasOffers && (
                <div className="suggestion-grid">
                  {filteredOffers.map((item) => {
                    const isBad = (src) =>
                      !src || src === "/upload-placeholder.png" || src === "/camera-placeholder.png";

                    const cleanedImages = Array.isArray(item.images)
                      ? item.images.filter((src) => !isBad(src))
                      : [];

                    const previewImage =
                      (!isBad(item.imageUrl) && item.imageUrl) ||
                      cleanedImages[0] ||
                      (!isBad(item.image) && item.image) ||
                      "/placeholder.png";

                    const plz = item.plz || (item.seller && item.seller.plz) || "";

                    return (
                      <div
                        key={item.id}
                        className="suggestion-card"
                        onClick={(e) => {
  if (!myUid || !isVerified) {
    e.preventDefault();
    setShowLoginModal(true);
    return;
  }

  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    if (previewOfferId !== item.id) {
      setPreviewOfferId(item.id);

      if (previewTimerRef.current) {
        clearTimeout(previewTimerRef.current);
      }

      previewTimerRef.current = setTimeout(() => {
        setPreviewOfferId(null);
      }, 2500);

      return;
    }

    navigate(`/angebot/${item.id}`);
    return;
  }

  navigate(`/angebot/${item.id}`);
}}
                   
                      >
                        <img src={previewImage} alt={item.title || "Angebot"} />
                        <div className={`suggestion-overlay ${previewOfferId === item.id ? "visible" : ""}`}>
                          <p>{item.title || "Angebot"}</p>
                          {plz && <p>PLZ: {plz}</p>}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {mapLightboxOpen && (
        <div className="lightbox-map-overlay">
          <div className="lightbox-map-content">
            <MapView
              key={`lightbox-${mapKey}`}
              offers={filteredOffers}
              hideLegend={true}
              forceResize={true}
              centerOverride={mapCenter}
              zoomOverride={mapZoom}
              onMapStateChange={handleMapStateChange}
            />
            <button onClick={() => setMapLightboxOpen(false)} className="lightbox-close-btn">
              Karte verkleinern
            </button>
          </div>
        </div>
      )}

      {showLoginModal && (
        <div className="modal-overlay" onClick={() => setShowLoginModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Login erforderlich</h3>
            <p>Um diese Funktionen nutzen zu können, logge dich bitte ein.</p>
            <div className="modal-buttons">
              <button className="cancel-btn" onClick={() => setShowLoginModal(false)}>
                Schließen
              </button>
              <button className="green-button" onClick={() => navigate("/login")}>
                Zum Login
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BrowsePage;